import { Injectable } from '@angular/core';
import { IsAny, IsNotNull, IsNotNullOrEmpty, IsNull } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { UserService } from '../user.service';
import { Candidate } from '@apply4u/models/talent-messenger/candidate';
import * as CryptoJS from 'crypto-js/index.js'
import { LocalstorageService } from '../localstorage.service';
import { LoginTypeKeys } from '@apply4u/shared/constant/Local-storage-keys/login-type-keys';
import { TalentMessengerKeys } from '@apply4u/shared/constant/Local-storage-keys/talent-messenger';
import { ContextService } from '../context-service';
import { AuthService } from '../auth-services/auth.service';

@Injectable()
export class TalentMessengerService {
  private iframe: any;

  constructor(private loginSecurity: UserService,
    private contextService: ContextService,
    private authService:AuthService,
    private localStorageService: LocalstorageService) { }

  LoadTalentMessengerWidget(window: any, jobId: number): void {   
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://loader.flashrecruit.com/widget.js`;
    script.onload = () => {     
      this.configureTalentMessengerWidget(window, jobId, this.localStorageService, this.loginSecurity,this.authService,this.contextService.IsUserLoggedIn);
    };
    document.body.appendChild(script);
  }

   RemoveTalentMessengerWidget(): void {
    try {
      if (IsNotNull(this.iframe)) {
        this.iframe.shutdown();
        this.iframe = undefined;
        const element = document.querySelectorAll(`script[src='https://loader.flashrecruit.com/widget.js']`);
        if (IsNotNull(element) && element.length > 0) {
          element.forEach(e => {
            e.remove();
          });
        }
      }
    }
    catch (error) {
      console.log("Error while unloading widget",error);
    }
  }

  private configureTalentMessengerWidget(window: any, jobId: number, localStorage: LocalstorageService, loginSecurity: UserService,authService:AuthService, isLoggedIn:boolean): void {
    const partner_Id = 'hY3f3l5Acwyud';
    const loginEmail = this.localStorageService.GetItem(LoginTypeKeys.LoginName);
    const options = {
      render: {
        autoboot: false,
        container: document.getElementById(`talent-widget-container`),
        primaryColor: `#077e36`,
        primaryTextColor: `#fff`,
        bubble: true,
        applyLinkTarget: `_self`,
        termsAndConditionsMarkup: `<p>By clicking on Apply you agree to Apply4U 
       <a href="https://www.apply4u.co.uk/privacy-and-terms" target="_blank">Terms & Conditions</a>
       and <a href="https://www.apply4u.co.uk/privacy-and-terms" target="_blank">Privacy Policy</a> and  to receive Apply4U emails.</p>`
      },
      callbacks: {
        onMatchCreated: function (candidate: any, match: any, meta: any) {         
          CaputureCandidateInfo(localStorage, loginSecurity,authService, candidate,isLoggedIn);
        },
        onApply: function (user: any, job: any, meta: any) {          
          if (IsNotNull(user) && IsNotNullOrEmpty(user.email) && IsNotNull(job) && IsNotNullOrEmpty(job.externalId)) {          
            ProcessJobApply(user.email, loginSecurity, localStorage,authService,isLoggedIn);
          }
        }
      }
    };

    if (isLoggedIn && IsNotNullOrEmpty(loginEmail)) {
      const secretKey = "HUv8JdqtOm6HZYLm1wE0zT3UZD7wbBJTw";
      const hmac = CryptoJS.HmacSHA256(loginEmail, secretKey);
      const signature = hmac.toString(CryptoJS.enc.Hex);
      const userName = this.localStorageService.GetItem(LoginTypeKeys.UserFirstName);
      options["candidate"] = {
        email: loginEmail,
        emailSignature: signature,
        name: userName,
        partnerId: partner_Id
      }
    }

    try {
      this.iframe = window.frSetup('match', partner_Id, jobId, options);

      if (IsNotNull(this.iframe)) {
        this.iframe.boot();
      }
    }
    catch (error) {
      console.log("Error while loading widget", error);
    }
  }
}

export function CaputureCandidateInfo(localStorage: LocalstorageService, loginSecurity: UserService,authService:AuthService, candidate: Candidate, isLoggedIn:boolean): void { 
  if (IsNotNull(candidate) && IsNotNullOrEmpty(candidate.email)) {
    if (!(isLoggedIn)) {
      loginSecurity.GetEmailAlreadyExist(candidate.email).subscribe(result => {
        if (IsAny(result)) {
           if(authService.AutoSignInSync(candidate.email, "apply4udirect")){
            loginSecurity.LoadUserProfile(candidate.email,false);
           }
        } else {
          localStorage.SetItem(TalentMessengerKeys.TalentCandiate, JSON.stringify(candidate));         
        }
      });
    }
  }
}

export function ProcessJobApply(userEmail: string, userService: UserService, localStorageService: LocalstorageService,authService:AuthService, isLoggedin : boolean): void { 
  const talentApplyElement = document.getElementById("talentApply");
  if (isLoggedin) {      
    if(IsNotNull(talentApplyElement)){
      talentApplyElement.click();
    }
  } else {
    const talentCandidate = localStorageService.GetItem(TalentMessengerKeys.TalentCandiate);
    let candidate: Candidate = null;

    if (IsNull(talentCandidate)) {
      candidate = new Candidate();
      candidate.email = userEmail;
      localStorageService.SetItem(TalentMessengerKeys.TalentCandiate, JSON.stringify(candidate));
    } else {
      candidate = JSON.parse(talentCandidate);
    } 

    if (IsNotNull(candidate) && IsNotNullOrEmpty(candidate.email)) {      
      userService.GetEmailAlreadyExist(candidate.email).subscribe(result => {
        if (IsAny(result)) {
          if(authService.AutoSignInSync(candidate.email, "apply4udirect")) {
            userService.LoadUserProfile(candidate.email,false);
            if(IsNotNull(talentApplyElement)){
              talentApplyElement.click();
            }          
          };
        } else {
          if(IsNotNull(talentApplyElement)){
            talentApplyElement.click();
          }          
        }        
      });
    }           
  }
}
